import CheckIcon from '@mui/icons-material/Check'
import {
    Box,
    Dialog,
    DialogContent,
    Fade,
    Typography
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { motion } from 'framer-motion'
import React from 'react'


export const SuccessDialog = ({ open, onClose }) => {
  const theme = useTheme();
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      TransitionComponent={Fade}
      transitionDuration={500}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          padding: '16px',
          textAlign: 'center',
          overflow: 'hidden',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      <DialogContent>
        <Box sx={{ position: 'relative', width: '80px', height: '80px', mx: 'auto', mb: 2 }}>
          <Box
            component={motion.div}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            sx={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: 'linear-gradient(to right top, #4caf50, #66bb6a)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)'
            }}
          >
            <CheckIcon
              component={motion.svg}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              sx={{ color: 'white', fontSize: '40px' }}
            />
          </Box>
          
          {/* Animated particles */}
          {[...Array(8)].map((_, i) => {
            const angle = (i / 8) * Math.PI * 2;
            const x = Math.cos(angle) * 50;
            const y = Math.sin(angle) * 50;
            
            return (
              <Box
                key={i}
                component={motion.div}
                initial={{ x: 0, y: 0, scale: 0, opacity: 0 }}
                animate={{ x, y, scale: [0, 1, 0], opacity: [0, 1, 0] }}
                transition={{ delay: 0.7 + (i * 0.05), duration: 0.8, ease: "easeOut" }}
                sx={{
                  position: 'absolute',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: '#66bb6a',
                  top: '50%',
                  left: '50%',
                  marginTop: '-4px',
                  marginLeft: '-4px'
                }}
              />
            );
          })}
        </Box>
        
        <Typography
          component={motion.h2}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          variant="h5"
          fontWeight="bold"
          sx={{
            mt: 2,
            mb: 1,
            background: 'linear-gradient(to right, #2e7d32, #4caf50)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          Login Successful!
        </Typography>
        
        <Typography
          component={motion.p}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          variant="body1"
          color="text.secondary"
          sx={{ mt: 1 }}
        >
          Welcome back! You're now signed in.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};